import S from './CareerEdit.module.scss';
import C from '../../Resume.module.scss';
import 'react-datepicker/dist/react-datepicker.css';

import React, { Dispatch, SetStateAction, useEffect, useState, FocusEvent } from 'react';
import { CareerType, EmploymentType, ResumeType } from '../../../../../types/ResumeTypes';
import { DateTimeUtils } from '../../../../../utils/DateTimeUtils';
import SelectDateBox from '../../../../common/SelectDateBox';
import SearchDropdown from '../../../../common/SearchDropdown';
import { useRecoilValue } from 'recoil';
import { IvyAuthorizationTokenAtom } from '../../../../../recoil/Authorization.recoil';
import { DummyCareer } from '../../../../../constants/IvyConstants';
import { ResumeTabsType } from '../../../../../types/ResumeTypes';
interface CareerEditProps {
  careers: CareerType[];
  setResume: Dispatch<SetStateAction<ResumeType>>;
  resumeTabs: ResumeTabsType;
}

const CareerEdit = (props: CareerEditProps) => {
  const { careers, setResume, resumeTabs } = props;

  const addCareer = (data: CareerType) => {
    setResume((prevResume) => {
      const careers = [...prevResume.careers] || [];
      careers.push(data);

      return {
        ...prevResume,
        careers,
      };
    });
  };

  const removeCareer = (index: number) => {
    setResume((prevResume) => {
      const updatedCareers = [...prevResume.careers];

      if (updatedCareers.length === 1) {
        return {
          ...prevResume,
          careers: [],
        };
      } else {
        updatedCareers.splice(index, 1); // 해당 index의 요소를 제거
        return {
          ...prevResume,
          careers: updatedCareers,
        };
      }
    });
  };

  useEffect(() => {
    if (careers !== undefined && careers.length === 0) {
      // addCareer(makeDummyCareers());
    }
  }, [careers]);

  return (
    <>
      <section ref={resumeTabs[2].element} className={`${C.basic_edit_section} wrapper`}>
        <h4 className={`${C.basic_edit_title} h4`}>경력사항</h4>
        <div className={C.basic_wrap}>
          <div className={C.basic_title}>
            <p className="b1">경력</p>
          </div>
          <div className={C.basic_input_wrap}>
            {careers?.map((career, index) => {
              return (
                <React.Fragment key={`career-edit-${index}`}>
                  <CareerEditElement index={index} career={career} setResume={setResume} />
                  <button
                    className={`${C.plus_minus_button} ${C.minus_button}`}
                    onClick={() => {
                      removeCareer(index);
                    }}
                  ></button>

                  <hr />
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <div className={C.plus_button_area}>
          <button
            className={`${C.plus_minus_button} ${C.plus_button}`}
            onClick={() => {
              addCareer(DummyCareer);
            }}
          ></button>
        </div>
        <hr />
      </section>
    </>
  );
};

interface CareerEditElementProps {
  index: number;
  career: CareerType;
  setResume: Dispatch<SetStateAction<ResumeType>>;
}

const CareerEditElement = (props: CareerEditElementProps) => {
  const { index, career, setResume } = props;
  const token = useRecoilValue(IvyAuthorizationTokenAtom);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const makeDummyCareers = () => {
    return {
      employmentType: 'PERMANENT_EMPLOYEE',
      name: '',
      position: '',
      isEmployed: true,
      startAt: '',
      endAt: '',
      description: '',
    } as CareerType;
  };

  const updateField = (index: number, fieldName: keyof CareerType, value: string) => {
    setResume((prevResume) => {
      const updatedCareers = [...prevResume.careers];
      updatedCareers[index] = {
        ...updatedCareers[index],
        [fieldName]: value,
      };
      return {
        ...prevResume,
        careers: updatedCareers,
      };
    });
  };

  const updateIsEmployedField = (index: number, value: boolean) => {
    setResume((prevResume) => {
      const updatedCareers = [...prevResume.careers];
      updatedCareers[index] = {
        ...updatedCareers[index],
        isEmployed: value,
      };
      return {
        ...prevResume,
        careers: updatedCareers,
      };
    });
  };

  const updateStartDateField = (value: Date, index: number) => {
    updateField(index, 'startAt', DateTimeUtils.toDateStringYYYYMM(value));
  };

  const updateEndDateField = (value: Date, index: number) => {
    updateField(index, 'endAt', DateTimeUtils.toDateStringYYYYMM(value));
  };

  const updateCareerNameField = (index: number, value: string) => {
    updateField(index, 'name', value);
  };

  const initCareer = (employmentType: EmploymentType) => {
    setResume((prevResume) => {
      const updatedCareers = [...prevResume.careers];
      updatedCareers[index] = makeDummyCareers();
      updatedCareers[index].employmentType = employmentType;
      return {
        ...prevResume,
        careers: updatedCareers,
      };
    });
  };

  const blurEventHandle = (setFocused: Function, e: FocusEvent<HTMLInputElement>) => {
    if (e.target.value === '') {
      setFocused(false);
    } else {
      setFocused(true);
    }
  };

  const checkInputValue = () => {
    if (career.position !== '') {
      setIsFocused(true);
    }
  };

  useEffect(() => {
    checkInputValue();
  }, []);

  return (
    <>
      <div className={C.basic_edit_input}>
        <select
          name="workType"
          id="workType"
          className="input-border input-select"
          value={career.employmentType}
          onChange={(e) => {
            initCareer(e.currentTarget.value as EmploymentType);
          }}
        >
          <option value="">고용형태</option>
          <option value="PERMANENT_EMPLOYEE">정규직</option>
          <option value="PART_TIME">파트 타임</option>
          <option value="CONTRACT_WORKER">계약직</option>
          <option value="INTERN">인턴</option>
          <option value="FREELANCER">프리랜서</option>
          <option value="ETC">기타</option>
        </select>
        <SearchDropdown
          selectedSearchValue={career.name}
          setSelectedSearchValue={updateCareerNameField}
          type={'enterprise'}
          token={token}
          selectedValueIndex={index}
        />
        <div className="input-grp">
          <label
            htmlFor={`position_${index}`}
            className={isFocused ? 'input-label focus-on' : 'input-label'}
          >
            직책
          </label>
          <input
            type="text"
            id={`position_${index}`}
            className="input-text input-border"
            onFocus={() => {
              setIsFocused(true);
            }}
            onBlur={(e) => {
              blurEventHandle(setIsFocused, e);
            }}
            onChange={(e) => {
              updateField(index, 'position', e.target.value);
              setIsFocused(true);
            }}
            value={career.position}
          />
        </div>
        <select
          name="nowWork"
          id="nowWork"
          className="input-border input-select"
          value={String(career.isEmployed)}
          onChange={(e) => {
            updateIsEmployedField(index, e.target.value === 'true');
          }}
        >
          <option value="true">재직중</option>
          <option value="false">
            {career.employmentType === 'PERMANENT_EMPLOYEE' ? '퇴사' : '기간 만료'}
          </option>
        </select>
        <div className={C.resume_period_date}>
          <SelectDateBox
            selectedDate={DateTimeUtils.stringToDateType(career.startAt, 'YYYY-MM')}
            setSelectedDate={updateStartDateField}
            type={'career-start-date'}
            index={index}
          />
        </div>
        {!career.isEmployed && (
          <div className={C.resume_period_date}>
            <SelectDateBox
              selectedDate={DateTimeUtils.stringToDateType(career.endAt, 'YYYY-MM')}
              setSelectedDate={updateEndDateField}
              type={'career-end-date'}
              index={index}
            />
          </div>
        )}
      </div>
      <div className={C.basic_wrap}>
        <div
          className={`${C.basic_edit_input} ${C.resume_textarea} input-grp input-textarea-height`}
        >
          <label htmlFor={`position_label_${index}`} className="textarea-label focus-on">
            상세내용
          </label>
          <textarea
            id={`position_label_${index}`}
            className="input-text input-border"
            value={career.description}
            onChange={(e) => {
              updateField(index, 'description', e.target.value);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default CareerEdit;
